import { faq as sections } from "../constants/eula";
let current_width_is_bigger = null;

/**
 *
 */
class EulaUtils {
    /**
     * @param {string} id id of container
     */
    static faq(id) {
        this.#loadFaqs(id);

        $(window).on("resize", () => {
            this.#loadFaqs(id);
        });
    }

    /**
     *loads faqs based on device width
     *
     * @memberof EulaUtils
     * @param {string} id
     */
    static #loadFaqs(id) {
        const screen_width = document.body.clientWidth;
        const is_bigger = screen_width > 776;

        if (current_width_is_bigger !== is_bigger) {
            if (screen_width > 766) {
                this.#loadDesktopFaqs(id);
            } else {
                this.#loadMobileFaqs(id);
            }
            current_width_is_bigger = is_bigger;
        }
    }

    /**
     *loads faq for mobile
     *
     * @memberof EulaUtils
     * @param {string} id
     */
    static #loadMobileFaqs(id) {
        const $mobile_section = $(`#${id} .mobile_faq`);
        const all_sections_html = sections
            .map((section) => {
                const section_name = section.section;
                const section_id = section_name + "_section";
                const section_heading_id = section_name + "_heading";
                const section_collapse_id = section_name + "_collapse";
                const questions_html = section.questions
                    .map((question, index) => {
                        const question_heading_id =
                            section_name + "_q" + (index + 1) + "_heading";
                        const question_collapse_id =
                            section_name + "_q" + (index + 1) + "_collapse";
                        return `
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="${question_heading_id}">
                            <button class="accordion-button text-end collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#${question_collapse_id}"
                                aria-expanded="false" aria-controls="${question_collapse_id}">
                                <span class="ps-10px">${question.question}</span>
                            </button>
                        </h2>
                        <div id="${question_collapse_id}" class="accordion-collapse collapse"
                            aria-labelledby="${question_heading_id}" data-bs-parent="#${section_id}">
                            <div class="accordion-body">
                                ${question.answer}
                            </div>
                        </div>
                    </div>
                `;
                    })
                    .join("");
                return `
                <div class="accordion-item main_item">
                    <h2 class="accordion-header" id="${section_heading_id}">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#${section_collapse_id}" 
                            aria-expanded="true" aria-controls="${section_collapse_id}"
                        >
                            ${section.title}
                        </button>
                    </h2>
                    <div id="${section_collapse_id}" class="accordion-collapse collapse"
                        aria-labelledby="${section_heading_id}" data-bs-parent="#mobile_accordion">
                        <div class="accordion-body">
                            <div class="accordion" id="${section_id}">${questions_html}</div>
                        </div>
                    </div>
                </div>
            `;
            })
            .join("");

        const mobile_faqs_html = `
            <div class="accordion" id="mobile_accordion">
                                ${all_sections_html}
            </div>
        `;

        $mobile_section.empty().append(mobile_faqs_html);
    }

    /**
     *loads faq for desktop
     *
     * @memberof EulaUtils
     * @param {string} id
     */
    static #loadDesktopFaqs(id) {
        const $desktop_section_menu = $(
            `#${id} .desktop_faq .faq_desktop_section.faq_menu`
        ).empty();
        const $desktop_section_content = $(
            `#${id} .desktop_faq .faq_desktop_section.faq_content`
        ).empty();

        // menu
        const menu_items_html = sections
            .map((section, index) => {
                return `<li data-for="#${section.section}_section_desktop" 
                    class="${index === 0 ? "active" : ""}">${
                    section.title
                }</li>`;
            })
            .join("");
        const $menu_html = $(`<ul class="faqs_menu">${menu_items_html}</ul>`);
        $menu_html
            .appendTo($desktop_section_menu)
            .on("click", "li", (event) => {
                const $target = $(event.target);
                const section_id = $target.data("for");
                $(".desktop_accordion").hide();
                $(".desktop_accordion" + section_id).show();

                $menu_html.find("li.active").removeClass("active");
                $target.addClass("active");
            });

        // content
        const content_sections_html = sections
            .map((section, section_index) => {
                const section_name = section.section;
                const section_id = section_name + "_section_desktop";
                const questions_html = section.questions
                    .map((question, index) => {
                        const question_heading_id =
                            section_name + "_q" + (index + 1) + "_heading";
                        const question_collapse_id =
                            section_name + "_q" + (index + 1) + "_collapse";
                        return `
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="${question_heading_id}">
                            <button class="accordion-button text-end collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#${question_collapse_id}"
                                aria-expanded="false" aria-controls="${question_collapse_id}">
                                ${question.question}
                            </button>
                        </h2>
                        <div id="${question_collapse_id}" class="accordion-collapse collapse"
                            aria-labelledby="${question_heading_id}" data-bs-parent="#${section_id}">
                            <div class="accordion-body">
                                ${question.answer}
                            </div>
                        </div>
                    </div>
                `;
                    })
                    .join("");

                return `<div 
                        class="accordion desktop_accordion" 
                        id="${section_id}"  ${
                    section_index !== 0 ? 'style="display:none"' : ""
                }
                    >${questions_html}</div>`;
            })
            .join("");

        $desktop_section_content.append(content_sections_html);
    }
}

export { EulaUtils };
